import moment from "moment";
import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/EntityGrid";

const useTrafficGridColumns = (): Array<SimpleEntityGridColumn> => {
    const { formatMessage } = useIntl();
    return [
        {
            field: "domain",
            headerName: formatMessage({ id: "sites.grid.col.domain" }),
            pinned: "left",
        },
        {
            field: "network",
            headerName: formatMessage({ id: "sites.grid.col.pbn" }),
            maxWidth: 70,
        },
        {
            field: "traffic",
            headerName: formatMessage({ id: "sites.grid.col.traffic" }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            maxWidth: 80,
        },
        {
            field: "kw",
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            headerName: formatMessage({ id: "sites.grid.col.kw" }),
            maxWidth: 70,
        },
        {
            field: "boost",
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            headerName: formatMessage({ id: "monitoring.grid.col.boost" }),
            maxWidth: 100,
        },
        {
            field: "top5",
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            headerName: formatMessage({ id: "monitoring.grid.col.canBeBoost" }),
            maxWidth: 120,
        },
        {
            field: "lastBoostDate",
            filter: "agDateColumnFilter",
            valueGetter: ({ data }) =>
                data?.lastBoostDate ? moment(data.lastBoostDate).format("DD/MM/YYYY") : "N/A",
            cellClassRules: {
                "order-success": ({ data }: any) =>
                    moment(data.lastBoostDate).unix() >= moment().subtract(2, "month").unix(),
            },
            headerName: formatMessage({ id: "monitoring.grid.col.lastBoostDate" }),
            maxWidth: 110,
        },
    ];
};

export default useTrafficGridColumns;
